import request from '@/tools/request'
import { HTTP } from './http'

export type OssRes = {
  accessKeyId: string
  accessKeySecret: string
}

export const GET_OSSSELECT = () =>
  request.GET<OssRes>(`${HTTP}/upload/getOssLedgerSecret`)
import request from '@/tools/request'
import { HTTP } from './http'

export type OssRes = {
  accessKeyId: string
  accessKeySecret: string
}

export const GET_OSSSELECT = () =>
  request.GET<OssRes>(`${HTTP}/upload/getOssLedgerSecret`)
